// Mock data for ICD Landing Page

// Unsplash photo IDs are stable. We append `&auto=format&q=80&w=560` so
// the image is small (the holo-screen renders at ~220px in the 3D scene)
// and only loads when the planet is actually hovered/selected (lazy/async).
const _UNSPLASH = (id) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=560&q=80`;

export const services = [
  {
    id: 1,
    title: "New Business Consultations",
    description: "Strategic planning sessions for startups and entrepreneurs. We help you define your market positioning, target audience, and create a roadmap for sustainable growth.",
    icon: "Target",
    image_url: _UNSPLASH("1552664730-d307ca884978"),
  },
  {
    id: 2,
    title: "Professional Logos",
    description: "Custom logo design that captures your brand essence. From concept to final delivery, we create memorable visual identities that make lasting impressions.",
    icon: "Palette",
    image_url: _UNSPLASH("1626785774573-4b799315345d"),
  },
  {
    id: 3,
    title: "Landing Pages",
    description: "High-converting landing pages designed to capture leads and drive action. Optimized for performance, mobile-responsive, and built for results.",
    icon: "Globe",
    image_url: _UNSPLASH("1460925895917-afdab827c52f"),
  },
  {
    id: 4,
    title: "Complete Website Design & Launch",
    description: "Full-service website development from strategy to launch. Custom design, seamless functionality, and ongoing support to establish your digital presence.",
    icon: "Rocket",
    image_url: _UNSPLASH("1517694712202-14dd9538aa97"),
  },
  {
    id: 5,
    title: "Publishing/Printings",
    description: "Professional print design and production for business cards, brochures, catalogs, packaging, and all your printed marketing materials.",
    icon: "ShoppingBag",
    image_url: _UNSPLASH("1517842645767-c639042777db"),
  },
  {
    id: 6,
    title: "Brand Development",
    description: "Comprehensive brand strategy including messaging, visual identity, brand guidelines, and positioning to differentiate you in the marketplace.",
    icon: "Zap",
    image_url: _UNSPLASH("1572044162444-ad60f128bdea"),
  },
  {
    id: 7,
    title: "Content & Media Creation",
    description: "Engaging content that tells your story. Photography, videography, copywriting, and multimedia assets that connect with your audience.",
    icon: "TrendingUp",
    image_url: _UNSPLASH("1542038784456-1ea8e935640e"),
  },
  {
    id: 8,
    title: "Digital Marketing & Ads",
    description: "Data-driven campaigns across social media, Google Ads, and digital platforms. We maximize ROI with targeted strategies that generate leads and sales.",
    icon: "TrendingUp",
    image_url: _UNSPLASH("1551288049-bebda4e38f71"),
  },
  {
    id: 9,
    title: "Automation & Systems",
    description: "Streamline your business operations with custom automation solutions. From email workflows to CRM integration, we help you work smarter, not harder.",
    icon: "Zap",
    image_url: _UNSPLASH("1551434678-e076c223a692"),
  },
  {
    id: 10,
    title: "Business Growth Consulting",
    description: "Strategic consulting for scaling businesses. Market analysis, expansion planning, revenue optimization, and executive coaching to accelerate your growth.",
    icon: "Rocket",
    image_url: _UNSPLASH("1611974789855-9c2a0a7236a3"),
  }
];

export const processSteps = [
  {
    number: 1,
    title: "Discovery & Consultation",
    description: "We dive deep into your vision, goals, and market to craft a strategic foundation.",
    icon: "Search"
  },
  {
    number: 2,
    title: "Creative Concept & Strategy",
    description: "Our team develops unique concepts aligned with your brand DNA and growth objectives.",
    icon: "Lightbulb"
  },
  {
    number: 3,
    title: "Design & Development",
    description: "We bring your brand to life with cutting-edge design and flawless execution.",
    icon: "Paintbrush"
  },
  {
    number: 4,
    title: "Review & Refinement",
    description: "Collaborative iterations ensure every detail exceeds your expectations.",
    icon: "RefreshCw"
  },
  {
    number: 5,
    title: "Launch & Scale Support",
    description: "We deploy your brand and provide ongoing support to maximize impact and growth.",
    icon: "Rocket"
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "Nova Dynamics",
    category: "Tech Startup",
    result: "400% Lead Increase",
    image: "https://images.unsplash.com/photo-1635657987551-1ff6d5a7efd7"
  },
  {
    id: 2,
    title: "Apex Ventures",
    category: "E-commerce Brand",
    result: "Full Website + Merch Line",
    image: "https://images.unsplash.com/photo-1751821535460-bf944d3489a4"
  },
  {
    id: 3,
    title: "Quantum Labs",
    category: "SaaS Platform",
    result: "Complete Brand Identity",
    image: "https://images.unsplash.com/photo-1667670778881-537035257bd8"
  },
  {
    id: 4,
    title: "Digital Forge",
    category: "Creative Agency",
    result: "300% Social Engagement",
    image: "https://images.pexels.com/photos/8108728/pexels-photo-8108728.jpeg"
  },
  {
    id: 5,
    title: "FutureTech Inc",
    category: "Enterprise Solution",
    result: "Market Leader in 6 Months",
    image: "https://images.unsplash.com/photo-1683321201755-67c6f575a3bc"
  },
  {
    id: 6,
    title: "Neon Networks",
    category: "Tech Startup",
    result: "Series A Funding Success",
    image: "https://images.unsplash.com/photo-1449157291145-7efd050a4d0e"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    role: "CEO",
    company: "Nova Dynamics",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
    quote: "We were struggling to stand out in a crowded market. ICD took the time to understand our vision and created a brand identity that actually resonates with our target audience. The rebrand helped us close three major clients in the first quarter."
  },
  {
    id: 2,
    name: "Marcus Rivera",
    role: "Founder",
    company: "Apex Ventures",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop",
    quote: "I've worked with several agencies before, but ICD's process was different. They asked the right questions upfront and delivered exactly what we needed—no endless revisions. Our new website loads fast and converts visitors like never before."
  },
  {
    id: 3,
    name: "Elena Volkov",
    role: "CMO",
    company: "Quantum Labs",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop",
    quote: "What impressed me most was their strategic thinking. They didn't just make things look good—they helped us clarify our messaging and identify gaps in our customer journey. The results speak for themselves: 40% increase in qualified leads."
  },
  {
    id: 4,
    name: "David Park",
    role: "Creative Director",
    company: "Digital Forge",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop",
    quote: "As a designer myself, I'm pretty picky. ICD brought fresh ideas to the table while respecting our existing brand equity. The collaboration felt like working with a true partner, not just a vendor. Highly recommend for anyone serious about their brand."
  }
];

export const stats = [
  { label: "Brands Transformed", value: 150 },
  { label: "Client Growth Rate", value: 98, suffix: "%" },
  { label: "Average ROI", value: 3.4, suffix: "x" }
];

export const brandStages = [
  "New Startup",
  "Growing Business",
  "Established Company"
];
